import React, { useContext, useEffect } from "react";
import { Form, Input, Button, Row, Col, Modal, notification  } from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";

const DeptoForm = ({open, isEdit, currentDepto, onFinish, onCancel }) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: currentDepto.name,
      });
    }
  }, [isEdit, currentDepto, form]);

  const handleComplete = async (values) => {
    try {
      values.name = values.name.trim();
      if (isEdit) {
        values.id = currentDepto.id;
        const response = await axios.put(`${globals.SERVICE_API_DB}/v1/update-department/${currentDepto.id}`,
          values,
          {
            headers: {
              "x-token": globals.token,
            }
          }
        );
        if (response?.data?.status === 0) {
          currentDepto = mergeProps(currentDepto, response?.data?.data);
          onFinish({status: "edited"}) 
        }
        form.resetFields();
        return;
      }
      const response = await axios.post(`${globals.SERVICE_API_DB}/v1/create-department`,
        values,
        {
          headers: {
            "x-token": globals.token,
          }
        }
      );
      onFinish({status: "created", newDepto: response?.data?.data})
      form.resetFields();
    } catch (error) {
      console.error("Error submitting form:", error);
      notification.error({
        message: "Error guardando departamento",
        placement: "bottomRight",
      });     
    } 
    
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  }

  const validatorEmpty = (rule, value) => {
    if (value && value.trim() === "") {
      return Promise.reject("Este campo es requerido");
    }
    return Promise.resolve();
  }

  return (
    <Modal
        title={isEdit ? "Editar Departamento" : "Crear departamento" }
        open={open}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
    {/* <LoadingModal open={loading} /> */}
    <Form
      form={form}
      layout="vertical"
      onFinish={handleComplete}
    >
      <Form.Item
        label="Nombre del depto."
        name="name"
        rules={[
          { required: true, message: "Este campo es requerido" },
          { validator: validatorEmpty }
        ]}
      >
        <Input/>
      </Form.Item>

      <Row justify="end">
        <Col>
          <Button style={{ marginRight: 8 }} type="primary" htmlType="submit">
            {isEdit ? "Actualizar" : "Crear"}
          </Button>
          <Button style={{ marginRight: 8 }} onClick={handleCancel}>
            Cancelar
          </Button>
        </Col>
      </Row>
    </Form>
    </Modal>
  );
};

export default DeptoForm;
